import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererParams } from 'ag-grid';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'idap-property-image-cell',
  template: `
<div class="image-cell-container text-center">
  <idap-property-image [property]="params.data"></idap-property-image>
</div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: []
})
export class PropertyImageCellComponent implements ICellRendererAngularComp {
  public params: ICellRendererParams;

  agInit(params: ICellRendererParams): void {
    this.params = params;
  }

  refresh(params: any): boolean {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/features/property/components/grids/property-image-cell.component.ts